/* @flow */
import configureReducer from "./configureReducer";
import configureMiddleware from "./configureMiddleware";
import { applyMiddleware, createStore } from "redux";

type Options = {
  initialState: Object,
  platformDeps?: Object,
  platformMiddleware?: Array<Function>
};

const configureStore = (options: Options) => {
  const { initialState, platformDeps = {}, platformMiddleware = [] } = options;

  const reducer = configureReducer(initialState);

  const middleware = configureMiddleware(
    initialState,
    platformDeps,
    platformMiddleware
  );

  const store = createStore(
    reducer,
    initialState,
    applyMiddleware(...middleware)
  );

  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/common/configureStore.js